export type MiddlePageValue = 'middle' | `middle${number}`;

const MIDDLE_PAGE_REGEX = /^middle(\d+)?$/;

function getMiddleSortIndex(value: string): number {
  if (value === 'middle') return 1;
  const matched = value.match(/^middle(\d+)$/);
  const index = matched ? Number(matched[1]) : Number.NaN;
  return Number.isNaN(index) ? Number.MAX_SAFE_INTEGER : index;
}

export function isMiddlePage(value: string | undefined | null): value is MiddlePageValue {
  return typeof value === 'string' && MIDDLE_PAGE_REGEX.test(value);
}

export function getMiddlePageValues(settings: any): MiddlePageValue[] {
  if (!settings) return [];

  const fromPageSettings = Array.isArray(settings?.pageSettings)
    ? settings.pageSettings
        .map((item: any) => item?.value)
        .filter((value: any) => isMiddlePage(value))
    : [];

  const fromSettingsKeys = Object.keys(settings)
    .filter((key) => isMiddlePage(key))
    .filter((key) => Array.isArray(settings[key]) && settings[key].length);

  const unique = Array.from(new Set<string>([...fromPageSettings, ...fromSettingsKeys]));
  unique.sort((a, b) => getMiddleSortIndex(a) - getMiddleSortIndex(b));
  return unique as MiddlePageValue[];
}

export function getMiddleScopedKey(pageValue: MiddlePageValue, baseMiddleKey: string): string {
  if (pageValue === 'middle') return baseMiddleKey;
  return baseMiddleKey.replace(/^middle/, pageValue);
}

export function getMiddleScopedValue<T = any>(
  source: Record<string, any> | undefined,
  pageValue: MiddlePageValue | undefined,
  baseMiddleKey: string
): T | undefined {
  if (!source) return undefined;
  if (!pageValue) return source[baseMiddleKey] as T | undefined;

  const scopedKey = getMiddleScopedKey(pageValue, baseMiddleKey);
  if (source[scopedKey] !== undefined) {
    return source[scopedKey] as T;
  }
  return source[baseMiddleKey] as T | undefined;
}

export function getMiddlePageFormList(settings: any, pageValue: MiddlePageValue | undefined): any[] {
  if (!settings || !pageValue) return settings?.middle || [];
  return settings?.[pageValue] || settings?.middle || [];
}
